import React, {createContext, useState} from 'react';
import {getErrorMessage} from "../../helpers/Utils";
import {Toast} from "../../components/common/Toast";
import BranchAddOnsService from "../../services/branch_product/BranchAddOnsService";
export const BranchAddOnsContext = createContext("BranchAddOnsContext");

const BranchAddOnsContextProvider = ({children}) => {

    const [loading, setLoading] = useState(false);
    const [totalElements, setTotalElements] = useState(0);
    const [branchAddOnsList, setBranchAddOnsList] = useState([]);

    const getAllBranchAddOns = async params => {
        try {

            setLoading(true);

            const res = await BranchAddOnsService.getAllBranchAddOns(params);
            setBranchAddOnsList(res.data.content);
            setTotalElements(res.data.totalElements);

            setLoading(false);

        } catch (error) {

            setLoading(false);

            const message = getErrorMessage(error);
            Toast("error", "Error", message);

        }
    }

    return (
        <BranchAddOnsContext.Provider
            value={{
                loading,
                totalElements,
                branchAddOnsList,
                getAllBranchAddOns,
            }}
        >
            {children}
        </BranchAddOnsContext.Provider>
    );
}

export default BranchAddOnsContextProvider;
